import { render, staticRenderFns } from "./ExchangeRate.vue?vue&type=template&id=f40bb4f0&scoped=true"
import script from "./ExchangeRate.vue?vue&type=script&lang=js"
export * from "./ExchangeRate.vue?vue&type=script&lang=js"
import style0 from "./ExchangeRate.vue?vue&type=style&index=0&id=f40bb4f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40bb4f0",
  null
  
)

export default component.exports